<template>
	<div class="memo" :style="{height: height + 'px'}">
		<div v-if="label !== false" class="memo__label">{{ label }} <span v-if="!optional">*</span></div>
		<textarea :style="{
			top: label === false ? '0' : '22px',
			padding: padding + 'px',
			height: (height - 19) + 'px'
		}" type="text" v-bind:value="value" @input="$emit('input', $event.target.value)"></textarea>
	</div>
</template>

<script>
	export default {
		props: {
			height: {
				type: Number,
				default: 82
			},
			name: String,
			label: [Boolean, String],
			value: [String, Number],
			optional: Boolean,
			weight: {
				type: Number,
				default: 1
			},
			padding: {
				type: String,
				default: '5'
			}
		}
	}
</script>

<style lang="scss">
	.memo {
		position: relative;

		&__label {
			position: absolute;
			pointer-events: none;
			left: 0;
			top: 0;
			font-size: 12px;
			color: #a0a3ac;

			& > span {
				color: #f7223f;
			}
		}

		& > textarea {
			position: absolute;
			left: 0;
			bottom: 0;
			background-color: #202127;
			width: 100% ! important;
			color: white;
			font-size: 14px;
			resize: none;
		}
	}
</style>